import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { not } from 'ramda';
import { useSelector } from 'react-redux';
import { PageSection } from '../../../Layout';
import ids from '../../QestIds';
import { ClassificationSection, MaterialClassificationSection, PreparationSection, ResultsSection } from './Sections';

const qestIds = [ids.soilClassification.ASTM_D2487.rev2017];

let AstmSoilClassificationWorksheet = ({ createWorksheetSelector }) => {
  const materialIsNotPeat = useSelector(pipe(createWorksheetSelector('Preparation.MaterialIsPeat'), not));

  const isCoarseGrained = useSelector(
    pipe(createWorksheetSelector('Preparation.CoarseOrFineGrainedMaterial'), (v) => v !== 'Fine-Grained')
  );

  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>

      <PageSection
        heading={(isCoarseGrained ? 'Coarse' : 'Fine') + '-Grained Material Classification'}
        visible={materialIsNotPeat}
      >
        <MaterialClassificationSection />
      </PageSection>

      <PageSection heading="Classification">
        <ClassificationSection />
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <WorksheetResultsSection heading="Results">
        <ResultsSection />
      </WorksheetResultsSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AstmSoilClassificationWorksheet = withInjectedProps(AstmSoilClassificationWorksheet);
AstmSoilClassificationWorksheet.qestIds = qestIds;

export default AstmSoilClassificationWorksheet;
export { AstmSoilClassificationWorksheet };
